import { styled } from '@glitz/react';

export const headerHeight = 70;

export const Heading = styled.h2({
  fontSize: t => t.facets?.heading?.fontSize,
  flexGrow: 1,
  margin: { xy: 0 },
  display: 'flex',
  alignItems: 'center',
  fontWeight: t => t.facets?.heading?.fontWeight,
});
